interface Ioptions {
  albumId?: string;
  albumPhotoId?: string;
  actionLinkUrl?: string;
}

export class PixleeAnalytics {
  constructor() {
    this.update();
  }

  pixlee_analytics: {
    events?: {
      trigger: (event: string, options: {}) => void;
    };
  } = {};

  widgetStyle = window.server_pdp_data
    ? 'PDP'
    : window.page_data && window.page_data.template === 'shop-our-insta'
    ? 'Shop our instagram'
    : window.page_data && window.page_data.template === 'pixlee'
    ? 'Inspo'
    : 'Undefined widget';

  initPixleeAnalytics(options: Ioptions) {
    // This method loads watch for 2 events initialy: Page with widget is loaded and observe when widget is in the viewport
    // [REVISIT] TimeOut is a hacky way to wait until script is inserted to the HEAD. Is there any other solutions???
    setTimeout(() => {
      try {
        // @ts-expect-error
        if (typeof Pixlee_Analytics !== 'undefined') {
          // @ts-expect-error
          this.pixlee_analytics = new Pixlee_Analytics('OkN5hpqghnzVy3VfJXWd');
          this.pixlee_analytics?.events?.trigger('opened:widget', {
            album_id: options.albumId,
            widget: this.widgetStyle,
          });
          this.sendDataOnViewPort(options);
        } else {
          console.log('Analytics is not defined');
        }
      } catch (error) {
        console.log(error);
      }
    }, 2000);
  }

  sendDataOnOpenLightbox(options: Ioptions) {
    // Send data on tag(+ icon) click
    try {
      this.pixlee_analytics?.events?.trigger('opened:lightbox', {
        album_id: options.albumId,
        album_photo_id: options.albumPhotoId,
      });
    } catch (error) {
      console.log(error);
    }
  }

  sendDataOnProductClick(options: Ioptions) {
    // Send data on product click in popover
    try {
      this.pixlee_analytics?.events?.trigger('action:clicked', {
        album_id: options.albumId,
        action_link_url: options.actionLinkUrl,
        album_photo_id: options.albumPhotoId,
      });
    } catch (error) {
      console.log(error);
    }
  }

  sendDataOnRightScroll(options: Ioptions) {
    // Send data when user scroll the widget to the right
    try {
      this.pixlee_analytics?.events?.trigger('nav:right', {
        album_id: options.albumId,
      });
    } catch (error) {
      console.log(error);
    }
  }

  sendDataOnViewPort(options: Ioptions) {
    // Observe when widget is in the viewport and send the event to Pixlee
    const config = {
      root: null,
      threshold: 0.2,
    };

    const callBack = (entries: IntersectionObserverEntry[], observer: IntersectionObserver) => {
      entries.forEach((entry) => {
        if (entry.intersectionRatio > config.threshold) {
          try {
            this.pixlee_analytics?.events?.trigger('widget:visible', {
              album_id: options.albumId,
              widget: this.widgetStyle,
            });
          } catch (error) {
            console.log(error);
          }
        }
      });
    };
    const observer = new IntersectionObserver(callBack, config);
    const widget = document.getElementById('PixleeFeed');

    if (widget) observer.observe(widget);
  }

  update() {
    try {
      const script = document.createElement('script');
      const pixleeEventsScript = 'https://assets.pixlee.com/assets/pixlee_events.js';
      script.src = pixleeEventsScript;
      document.head.appendChild(script);
    } catch (error) {
      console.log(error);
    }
  }
}

export default new PixleeAnalytics();
